import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { logGreyError as logGreyErrorWithMailbox } from 'owa-analytics';
import type { CustomDataMap, DatapointOptions } from 'owa-analytics-types';

export function logGreyError(
    eventName: string,
    error?: Error,
    customData?: CustomDataMap,
    options?: DatapointOptions
): Promise<void> {
    return logGreyErrorWithMailbox(eventName, getUserMailboxInfo(), error, customData, options);
}
